// libs
import React, { memo } from "react";
import styled from "@emotion/styled";

// components
import Header from "shared/components/Header/DesktopHeader";
import AuthModalWrapper from "shared/components/AuthModal/AuthModalWrapper";

// constants
import { DWEB_DISCOUNT_HEIGHT, DWEB_HEADER_HEIGHT } from "styles/base";

// styles
const Container = styled.div`
    padding-top: ${DWEB_HEADER_HEIGHT + DWEB_DISCOUNT_HEIGHT}px;
`;

// defs
interface IDesktopHeaderProviderProps {
    children: React.ReactNode;
    className?: string;
}

function DesktopHeaderProvider({ children, className }: IDesktopHeaderProviderProps) {
    return (
        <Container className={className}>
            <AuthModalWrapper>
                <Header />
                {children}
            </AuthModalWrapper>
        </Container>
    );
}

export default memo(DesktopHeaderProvider);
